import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';         // ✅ NEW: Import App instead of AcademicAssistant
import './styles.css';          // keep your styles

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />                     {/* ✅ NEW: Render App instead of AcademicAssistant */}
  </React.StrictMode>
);
